import asyncActionTypes from '../actions/types.js';
import QuoteRefundUIModel from '../../api-wrapper/ui-models/refund/quoteRefundModels/quoteRefund.js';

const initialState = {
  errorQuoteRefund: false,
  quoteRefundData: null,
  loadingQuoteRefund: false,
};

const quoteRefund = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_QUOTE_REFUND.START:
      return {
        ...state,
        errorQuoteRefund: false,
        loadingQuoteRefund: true,
      };
    case asyncActionTypes.RETRIEVE_QUOTE_REFUND.SUCCESS:
      const quoteData = new QuoteRefundUIModel(action.payload);
      return {
        ...state,
        errorQuoteRefund: false,
        loadingQuoteRefund: false,
        quoteRefundData: quoteData,
      };
    case asyncActionTypes.RETRIEVE_QUOTE_REFUND.FAIL:
      return {
        ...state,
        errorQuoteRefund: true,
        loadingQuoteRefund: false,
      };
    default:
      return state;
  }
};

export default quoteRefund;